<template>
    <excel-export class="w-100" :data="processedItems"
        :fields="excelFields" worksheet="Denuncias Karin" name="denuncias_karin.xlsx">
    </excel-export>
</template>

<script>
import { formatComment, formatBoolean, formatApproval} from '@/plugins/complianceScripts'
import ExcelExport from '@/components/shared/ExcelExport.vue';

export default {
    name: 'KarinReportExcel',

    components: {
        ExcelExport
    },

    props: {
        items: Array
    },

    computed: {
        processedItems() {
            if (!this.items) {
                return []
            }

            return this.items.map(item => ({
                ...item,
                status: formatApproval(item.approval),
                resolvedBy: item.approvalItem ? item.approvalItem.approverMail : '',
                approvalReason: item.approvalItem ? item.approvalItem.reason : '',
            }))
        },
        
        excelFields() {
            return {
                'Detalle': {
                    field: 'descripcion',
                    width: 60,
                },
                'Nombre afectado': {
                    field: 'accuserNombre',
                    width: 20,
                },
                'Correo afectado': {
                    field: 'accuserCorreo',
                    width: 30,
                },
                'RUT afectado': {
                    field: 'accuserRut',
                    width: 20,
                },
                'Persoanas denunciadas': {
                    field: 'reported',
                    width: 60,
                    callback: value => value.join(', ')
                },
                'Tipo de denuncia': {
                    field: 'denunciationType',
                    width: 25,
                },
                'Medidas preventivas': {
                    field: 'preventive',
                    width: 25,
                    callback: formatBoolean
                },
                'Comentarios': {
                    field: 'comments',
                    width: 60,
                    callback: value => value.map(formatComment).join(', ')
                },
                'Estado': {
                    field: 'status',
                    width: 25,
                },
                'Responsable de la resolución': {
                    field: 'resolvedBy',
                    width: 30,
                },
                'Motivo de la resolución': {
                    field: 'approvalReason',
                    width: 60,
                },
                
            }
        }
    }
}
</script>